module.exports = __webpack_public_path__ + "static/rewards-card-supply-drops-3a332d6f9e17f5cf3985d4002ba57311.png";